import { RefObject, useEffect } from "react"
import L from "leaflet"
import { KmGroups } from "../../shared-interfaces/km.groups"

const providedDataDistance = 5

const create5KmLayerGroupIfNeeded = (
  kmLayerGroup: L.LayerGroup,
  kilometerMarkerCoords: number[][],
  kmDistance: number) => {

  // 1 = 5 / 5
  // 2 = 10/ 5
  // 10 = 50 / 5
  const distanceMultiplier = kmDistance / providedDataDistance

  if (kmLayerGroup.getLayers().length === 0) {
    (kilometerMarkerCoords || []).forEach((coords, idx) => {
      // 0, 5, 10 or 0, 10, 20 or 0, 50, 100
      if (idx % distanceMultiplier !== 0) {
        return
      }
      const text = `<span>${idx * 5}</span>`
      const icon = L.divIcon({ className: "dist-marker", html: text, iconSize: [-1, -1] })
      const marker = L.marker(
        [coords[1], coords[0]],
        { title: text, icon: icon, zIndexOffset: -1000 })
      kmLayerGroup.addLayer(marker)
    })
  }
}

const addLayer = (map: RefObject<L.Map>, layer: L.LayerGroup, distance: number, kilometerMarkerCoords: number[][]) => {
  if (!map.current!.hasLayer(layer)) {
    // defer creation of km stones
    create5KmLayerGroupIfNeeded(layer, kilometerMarkerCoords, distance)
    map.current!.addLayer(layer)
  }
}

const display5AtZoomLevel = 10
const display10AtZoomLevel = 9
const display50AtZoomLevel = 7

const onZoomed = (map: RefObject<L.Map>, kmGroups: RefObject<KmGroups>, kilometerMarkerCoords: number[][]) => {
  const currZoom = map.current!.getZoom()
  if (currZoom >= display5AtZoomLevel) {

    map.current!.removeLayer(kmGroups.current!.kmLayerGroup10)
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup50)

    addLayer(map, kmGroups.current!.kmLayerGroup5, 5, kilometerMarkerCoords)

  } else if (currZoom < display5AtZoomLevel && currZoom >= display10AtZoomLevel) {
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup5)
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup50)

    addLayer(map, kmGroups.current!.kmLayerGroup10, 10, kilometerMarkerCoords)

  } else if (currZoom < display10AtZoomLevel && currZoom >= display50AtZoomLevel) {
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup5)
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup10)

    addLayer(map, kmGroups.current!.kmLayerGroup50, 50, kilometerMarkerCoords)

  } else {
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup5)
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup10)
    map.current!.removeLayer(kmGroups.current!.kmLayerGroup50)
  }
}

// if i do not create the kmGroup layer before hand (created in map ) the function layerGroup is undefined - hä??
export const useDistanceMarkerEffect = (kilometerMarkerCoords: number[][], mapVisible: boolean, map: RefObject<L.Map>, kmGroups: RefObject<KmGroups>) => {

  useEffect(() => {
    if (mapVisible && kilometerMarkerCoords && kmGroups.current) {
      map.current!.on("zoomend", () => onZoomed(map, kmGroups, kilometerMarkerCoords))
      // initial zoom state
      onZoomed(map, kmGroups, kilometerMarkerCoords)
    }
  }, [kilometerMarkerCoords, mapVisible, map, kmGroups])
}
